import { WebCheckinProps } from '@msc-b2c/interfaces/types';
import Webcheckin from './WebCheckin';
import { getActiveSession, useGetBookingQuery } from '@msc-b2c/shared-utils';
import { skipToken } from '@reduxjs/toolkit/query';
import { LoginMode } from '@msc-b2c/interfaces/enums';
import { removeSkeleton } from './helpers/helpers';

export function WebCheckinWrapper(webCheckinProps: Readonly<WebCheckinProps>) {
  const { loginMode, bookingNumber = '' } = getActiveSession();
  const bookingQuery = useGetBookingQuery(bookingNumber !== '' ? bookingNumber : skipToken);
  const booking = bookingNumber !== '' ? bookingQuery?.data : undefined;

  if (loginMode === LoginMode.LIGHT) {
    removeSkeleton();
  }

  return loginMode !== LoginMode.LIGHT && booking && <Webcheckin {...webCheckinProps} />;
}

WebCheckinWrapper.aemResourceType = 'b2c-website-foundation/components/mymsc/webcheckin';

export default WebCheckinWrapper;
